import React from 'react'
import Link from 'gatsby-link'
import SbEditable from 'storyblok-react'

import Components from './../Components'

import styles from './styles.module.scss'

const Logos = (props) => {
	return (
		<SbEditable content={props.blok}>
			<ul className={styles['logos']}>
                {props.blok.logo_items && props.blok.logo_items.map((blok) => 
                    React.createElement(Components(blok.component), {
                        key: blok._uid, 
                        blok: blok
                    })
                )}
            </ul>
		</SbEditable>
	)
}

export default Logos
